'use client';

import { useTranslations } from 'next-intl';

import { TrackedButton } from '@/components/button';
import { ConsultationLanguagesNotice } from '@/components/consultation-languages-notice';
import { TRACKED_EVENT_POSITION } from '@/constants';
import { useInquiryChat } from '@/components/channel-talk';

const SUPPORT_HERO_LABEL = 'support_page_inquiry';

const HERO_CTA_CLASS =
  'mt-5 h-[56px] w-full rounded-[10px] bg-[#040435] text-[18px] font-medium leading-[26px] tracking-[-0.18px] text-white transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#040435] focus-visible:ring-offset-2 md:mt-6 md:h-[60px] md:w-[648px]';

export function HeroInquiryTrigger() {
  const t = useTranslations('Support.funnel.hero');
  const inquiryChatProps = useInquiryChat();

  return (
    <>
      <TrackedButton
        label={SUPPORT_HERO_LABEL}
        position={TRACKED_EVENT_POSITION.MAIN_HEADER}
        {...inquiryChatProps}
        className={HERO_CTA_CLASS}
      >
        {t('cta')}
      </TrackedButton>
      <div className="mt-3 w-full md:mt-6 md:w-[648px]">
        <ConsultationLanguagesNotice />
      </div>
    </>
  );
}
